import { render } from "./GastoForm.vue?vue&type=template&id=6fb40448&scoped=true"
import script from "./GastoForm.vue?vue&type=script&lang=js"
export * from "./GastoForm.vue?vue&type=script&lang=js"

import "./GastoForm.vue?vue&type=style&index=0&id=6fb40448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb40448"]])

export default __exports__